export default {
	data() {
		return {
            height: 500,
            height1:500,
            screenWidth:''
		}
	},
    mounted() {
        window.onresize = () => { //屏幕尺寸变化就重新赋值
            return (() => {
                // console.log(this.screenWidth)
                this.screenWidth = document.documentElement.clientWidth
            })()
        }
    },
    methods:{
        tiao(url){
            console.log(url,'url')
            if(!url){
                return
            }
            window.open(url)
        }
    },
    watch: {
        screenWidth: {
            handler: function (val, oldVal) {
                var widtt = val < 1200 ? 1200 : val
               
                this.height = this.height1 / 1920 * widtt
            },
            immediate: true
        },
    },
    created: function () { 
        this.screenWidth = document.documentElement.clientWidth
      }
}



// WEBPACK FOOTER //
// ./src/utils/window.js